import createIcon from '../../createIcon';

/**
 * @component @name SelectAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1SDVWM0MzLjkgMyAzIDMuOSAzIDVaTTMgMTNINVYxMUgzVjEzWk03IDIxSDlWMTlIN1YyMVpNMyA5SDVWN0gzVjlaTTEzIDNIMTFWNUgxM1YzWk0xOSAzVjVIMjFDMjEgMy45IDIwLjEgMyAxOSAzWk01IDIxVjE5SDNDMyAyMC4xIDMuOSAyMSA1IDIxWk0zIDE3SDVWMTVIM1YxN1pNOSAzSDdWNUg5VjNaTTExIDIxSDEzVjE5SDExVjIxWk0xOSAxM0gyMVYxMUgxOVYxM1pNMTkgMjFDMjAuMSAyMSAyMSAyMC4xIDIxIDE5SDE5VjIxWk0xOSA5SDIxVjdIMTlWOVpNMTkgMTdIMjFWMTVIMTlWMTdaTTE1IDIxSDE3VjE5SDE1VjIxWk0xNSA1SDE3VjNIMTVWNVpNNyAxN0gxN1Y3SDdWMTdaTTkgOUgxNVYxNUg5VjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SelectAll = createIcon('SelectAll', [
  [
    'path',
    {
      d: 'M3 5H5V3C3.9 3 3 3.9 3 5ZM3 13H5V11H3V13ZM7 21H9V19H7V21ZM3 9H5V7H3V9ZM13 3H11V5H13V3ZM19 3V5H21C21 3.9 20.1 3 19 3ZM5 21V19H3C3 20.1 3.9 21 5 21ZM3 17H5V15H3V17ZM9 3H7V5H9V3ZM11 21H13V19H11V21ZM19 13H21V11H19V13ZM19 21C20.1 21 21 20.1 21 19H19V21ZM19 9H21V7H19V9ZM19 17H21V15H19V17ZM15 21H17V19H15V21ZM15 5H17V3H15V5ZM7 17H17V7H7V17ZM9 9H15V15H9V9Z',
      key: '1rlna6',
    },
  ],
]);

export default SelectAll;
